export interface Product {
  id: string
  name: string
  price: number
  image: string
  category: 'Produce' | 'Spices' | 'Staples' | 'Household'
  isWIC: boolean
  isEBT: boolean
  altText: string
  description?: string
}

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Fufu Flour (4lb)',
    price: 8.99,
    image:
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: true,
    isEBT: true,
    altText: 'Bag of premium Fufu flour, 4 pounds',
    description: 'Authentic plantain fufu flour for traditional swallow.',
  },
  {
    id: '2',
    name: 'Yellow Yams (2lb)',
    price: 5.49,
    image:
      'https://images.unsplash.com/photo-1588165171080-c89acfa5ee83?auto=format&fit=crop&q=80&w=800',
    category: 'Produce',
    isWIC: false,
    isEBT: true,
    altText: 'Fresh yellow yams, approximately 2 pounds',
    description:
      'Sweet and starchy yellow yams, perfect for boiling or frying.',
  },
  {
    id: '3',
    name: 'Scotch Bonnet Peppers',
    price: 3.99,
    image:
      'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&q=80&w=800',
    category: 'Produce',
    isWIC: false,
    isEBT: true,
    altText: 'Fresh red and yellow Scotch Bonnet peppers',
    description: 'Spicy and flavorful peppers essential for Caribbean cuisine.',
  },
  {
    id: '4',
    name: 'Green Plantains (Bunch)',
    price: 2.99,
    image:
      'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?auto=format&fit=crop&q=80&w=800',
    category: 'Produce',
    isWIC: true,
    isEBT: true,
    altText: 'Bunch of 4-5 fresh green plantains',
    description: 'Unripe green plantains, ideal for tostones or chips.',
  },
  {
    id: '5',
    name: 'Red Palm Oil (1L)',
    price: 12.99,
    image:
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: false,
    isEBT: true,
    altText: 'Bottle of unrefined red palm oil, 1 liter',
    description: 'Rich, authentic palm oil for soups and stews.',
  },
  {
    id: '6',
    name: 'Jollof Rice Mix',
    price: 4.5,
    image:
      'https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: false,
    isEBT: true,
    altText: 'Box of Jollof Rice seasoning mix',
    description: 'Spice blend for making perfect smoky Jollof rice.',
  },
  {
    id: '7',
    name: 'Diapers (Size 4)',
    price: 24.99,
    image:
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&q=80&w=800',
    category: 'Household',
    isWIC: true,
    isEBT: false,
    altText: 'Pack of baby diapers, size 4',
    description: 'Soft, absorbent diapers for active babies.',
  },
  {
    id: '8',
    name: 'Maggi Seasoning Cubes',
    price: 6.99,
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800',
    category: 'Spices',
    isWIC: false,
    isEBT: true,
    altText: 'Pack of Maggi seasoning cubes',
    description: 'Essential bouillon cubes for depth of flavor.',
  },
  {
    id: '9',
    name: 'Cassava Flour',
    price: 7.49,
    image:
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: true,
    isEBT: true,
    altText: 'Bag of fine cassava flour',
    description: 'Gluten-free flour made from whole cassava root.',
  },
  {
    id: '10',
    name: 'Dried Stockfish',
    price: 18.99,
    image:
      'https://images.unsplash.com/photo-1544943910-4c1dc44aab44?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: false,
    isEBT: true,
    altText: 'Pieces of dried stockfish',
    description: 'Premium dried cod for authentic soup flavor.',
  },
  {
    id: '11',
    name: 'Egusi Seeds (Ground)',
    price: 9.99,
    image:
      'https://images.unsplash.com/photo-1608797178974-15b35a64ede9?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: false,
    isEBT: true,
    altText: 'Container of ground Egusi melon seeds',
    description: 'Ground melon seeds for thickening soups.',
  },
  {
    id: '12',
    name: 'Fresh Okra (1lb)',
    price: 3.49,
    image:
      'https://images.unsplash.com/photo-1599305090598-fe179d501227?auto=format&fit=crop&q=80&w=800',
    category: 'Produce',
    isWIC: true,
    isEBT: true,
    altText: 'Fresh green okra pods',
    description: 'Tender okra pods for soups or frying.',
  },
  {
    id: '13',
    name: 'Curry Powder',
    price: 4.29,
    image:
      'https://images.unsplash.com/photo-1599909533730-f9f0c5e3c3a3?auto=format&fit=crop&q=80&w=800',
    category: 'Spices',
    isWIC: false,
    isEBT: true,
    altText: 'Jar of yellow curry powder',
    description: 'Aromatic blend of turmeric, coriander, and cumin.',
  },
  {
    id: '14',
    name: 'Coconut Milk (Can)',
    price: 2.49,
    image:
      'https://images.unsplash.com/photo-1585238341710-4a9b7a2bd4f3?auto=format&fit=crop&q=80&w=800',
    category: 'Staples',
    isWIC: false,
    isEBT: true,
    altText: 'Can of coconut milk',
    description: 'Creamy coconut milk for rice and peas or curries.',
  },
  {
    id: '15',
    name: 'Habanero Peppers',
    price: 3.49,
    image:
      'https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?auto=format&fit=crop&q=80&w=800',
    category: 'Produce',
    isWIC: false,
    isEBT: true,
    altText: 'Fresh orange habanero peppers',
    description: 'Very hot peppers for adding heat to dishes.',
  },
]
